import type { SVGProps } from 'react';

const SvgOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 13.05c-.55 0-1 .45-1 1v4c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-12c0-.55.45-1 1-1h4c.55 0 1-.45 1-1s-.45-1-1-1H6c-1.65 0-3 1.35-3 3v12c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-4c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M20.92 3.67a.9.9 0 0 0-.22-.32 1 1 0 0 0-.32-.21c-.12-.05-.25-.07-.37-.08h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59l-6.29 6.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l6.29-6.29v2.59c0 .55.45 1 1 1s1-.45 1-1V4.05c0-.13-.03-.26-.08-.38z"
    />
  </svg>
);
export default SvgOpen;
